<template>
  <div class="mb-4">
    <div class="caption mb-2 font-weight-medium grey--text text--darken-2">{{ label || 'Image' }}</div>
    
    <!-- Upload box -->
    <div
      v-if="!imageUrl"
      class="image-uploader-box d-flex flex-column align-center justify-center rounded"
      :style="{ borderColor: $vuetify.theme.dark ? '#555' : '#ccc' }"
      @click="triggerUpload"
    >
      <v-icon large color="grey lighten-1">mdi-image-plus</v-icon>
      <div class="caption grey--text mt-2">Click to upload</div>
    </div>
    
    <!-- Image preview -->
    <div v-else class="image-preview-container rounded">
       <v-img :src="imageUrl" max-height="150" contain class="grey lighten-4"></v-img>
       <div class="overlay d-flex align-center justify-center">
          <v-btn small color="white" class="mr-2 black--text" @click="triggerUpload">
            <v-icon left small color="primary">mdi-sync</v-icon> Change
          </v-btn>
          <v-btn small color="error" @click="removeImage">
            <v-icon left small>mdi-delete</v-icon> Remove
          </v-btn>
       </div>
    </div>

    <v-progress-linear v-if="uploading" indeterminate color="primary" class="mt-2 rounded"></v-progress-linear>

    <input
      ref="fileInput"
      type="file"
      style="display: none"
      accept="image/*"
      @change="onFileChange"
    />
  </div>
</template>

<script>
export default {
  name: "ImageUploader",
  props: {
    value: { type: String, default: "" },
    label: { type: String, default: "Image" }
  },
  data() {
    return {
      uploading: false,
      imageUrl: (this.value && typeof this.value === 'string' && this.value.indexOf('http') === 0) ? this.value : ''
    };
  },
  watch: {
    value(newVal) {
      var url = (newVal && typeof newVal === 'string' && newVal.indexOf('http') === 0) ? newVal : '';
      if (url !== this.imageUrl) {
        this.imageUrl = url;
      }
    }
  },
  methods: {
    removeImage() {
      this.imageUrl = '';
      this.$emit('input', '');
    },
    triggerUpload() {
      this.$nextTick(function() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.click();
        }
      });
    },
    async onFileChange(e) {
      var file = e.target.files[0];
      if (!file) return;

      this.uploading = true;
      try {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("type", "gopagesImage");
        if (this.$store && this.$store.state.companyDetails) {
          formData.append("companyId", this.$store.state.companyDetails.id);
        }

        var config = {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: this.$store.state.user ? this.$store.state.user.token : "",
          },
        };

        var response = await this.$http.post(
          this.$store.state.ENDPOINT + "/attachments/upload",
          formData,
          config
        );
        var attachment = response.body;
        var attachName = attachment.name || (attachment[0] && attachment[0].name) || '';
        if (!attachName) throw new Error("File name not returned by server");
        
        var url = 'https://storage.googleapis.com/godial-enterprise.appspot.com/' + encodeURI(attachName);
        this.imageUrl = url;
        var self = this;
        self.$nextTick(function() {
          self.$emit('input', url);
        });
      } catch (err) {
        console.error("Upload error", err);
        this.$swal && this.$swal("Error", "Failed to upload image", "error");
      } finally {
        this.uploading = false;
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";
      }
    }
  }
};
</script>

<style scoped>
.image-uploader-box {
  width: 100%;
  height: 120px;
  border: 2px dashed;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: var(--v-background-base, #f9f9f9);
}

.image-uploader-box:hover {
  background-color: rgba(0, 0, 0, 0.05);
  border-color: var(--v-primary-base) !important;
}

.image-uploader-box:hover .v-icon {
  color: var(--v-primary-base) !important;
}

.image-preview-container {
  width: 100%;
  border: 1px solid #ddd;
  overflow: hidden;
  position: relative;
}

.image-preview-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.image-preview-container:hover .overlay {
  opacity: 1;
}
</style>